import { render, staticRenderFns } from "./SpeedingReportDetails.vue?vue&type=template&id=a4caebe2&scoped=true&"
import script from "./SpeedingReportDetails.vue?vue&type=script&lang=js&"
export * from "./SpeedingReportDetails.vue?vue&type=script&lang=js&"
import style0 from "./SpeedingReportDetails.vue?vue&type=style&index=0&id=a4caebe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4caebe2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4caebe2')) {
      api.createRecord('a4caebe2', component.options)
    } else {
      api.reload('a4caebe2', component.options)
    }
    module.hot.accept("./SpeedingReportDetails.vue?vue&type=template&id=a4caebe2&scoped=true&", function () {
      api.rerender('a4caebe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Reports/SpeedingReportDetails.vue"
export default component.exports